import { render, staticRenderFns } from "./PracticeResourceEdit.vue?vue&type=template&id=12374f5a&scoped=true&"
import script from "./PracticeResourceEdit.vue?vue&type=script&lang=js&"
export * from "./PracticeResourceEdit.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12374f5a",
  null
  
)

export default component.exports